import React, { useMemo } from "react";
import PropTypes from "prop-types";

import Modal from "Components/Common/Modal";
import PermanentConnection from "pages/Consumer/ApplicationType/PermanentConnection";
import TemporaryConnection from "pages/Consumer/ApplicationType/TemporaryConnection";
import NameTransfer from "pages/Consumer/ApplicationType/NameTransferConnection";
import DemandReduction from "pages/Consumer/ApplicationType/DemandReduction";
import DemandExtension from "pages/Consumer/ApplicationType/DemandExtension";
import PremiseAmalgamation from "pages/Consumer/ApplicationType/PremiseAmalgamation";
import PremiseRemoval from "pages/Consumer/ApplicationType/PremiseRemoval";
import ShiftingOfService from "pages/Consumer/ApplicationType/ShiftingOfService";
import ChangeOfCategory from "pages/Consumer/ApplicationType/ChangeOfCategory";
import NetMetering from "pages/Consumer/ApplicationType/NetMeteringConnection";
import BackupPower from "pages/Consumer/ApplicationType/BackupPower";
import RemovalOfConnection from "pages/Consumer/ApplicationType/RemovalOfConnection";
import { applicationTypes } from "common/constant";

const getKeyByValue = (object, value) => {
  return Object.keys(object).find((key) => object[key] === value);
};

const ApplicationEditModal = ({
  applicationTypeId,
  applicationId,
  handleClose,
}) => {
  const editApplicationTypes = useMemo(
    () => ({
      1: (
        <PermanentConnection
          applicationId={applicationId}
          handleClose={handleClose}
        />
      ),

      2: (
        <TemporaryConnection
          applicationId={applicationId}
          handleClose={handleClose}
        />
      ),

      3: (
        <NameTransfer applicationId={applicationId} handleClose={handleClose} />
      ),

      4: (
        <DemandReduction
          applicationId={applicationId}
          handleClose={handleClose}
        />
      ),

      5: (
        <DemandExtension
          applicationId={applicationId}
          handleClose={handleClose}
        />
      ),

      6: (
        <PremiseAmalgamation
          applicationId={applicationId}
          handleClose={handleClose}
        />
      ),

      7: (
        <PremiseRemoval
          applicationId={applicationId}
          handleClose={handleClose}
        />
      ),

      8: (
        <ShiftingOfService
          applicationId={applicationId}
          handleClose={handleClose}
        />
      ),

      9: (
        <ChangeOfCategory
          applicationId={applicationId}
          handleClose={handleClose}
        />
      ),
      10: (
        <NetMetering applicationId={applicationId} handleClose={handleClose} />
      ),

      11: (
        <BackupPower applicationId={applicationId} handleClose={handleClose} />
      ),

      12: (
        <RemovalOfConnection
          applicationId={applicationId}
          handleClose={handleClose}
        />
      ),
    }),
    [applicationId]
  );

  return (
    <>
      {applicationTypeId && applicationId && (
        <Modal
          isOpen={!!applicationId}
          handleClose={handleClose}
          maxWidth="lg"
          title={`Edit ${getKeyByValue(applicationTypes, applicationTypeId)}`}
        >
          {editApplicationTypes[applicationTypeId]}
        </Modal>
      )}
    </>
  );
};
ApplicationEditModal.propTypes = {
  applicationTypeId: PropTypes.number,
  applicationId: PropTypes.number,
  handleClose: PropTypes.func,
};
export default ApplicationEditModal;
